import { z } from '@hono/zod-openapi'

export const idZ = z
  .number()
  .openapi({ description: '請求明細ID', example: 5001 })
export type id = z.infer<typeof idZ>

export const invoiceIdZ = z
  .number()
  .openapi({ description: '紐づく請求書ID', example: 1001 })
export type invoiceId = z.infer<typeof invoiceIdZ>

export const planIdZ = z
  .number()
  .nullable()
  .openapi({ description: '課金対象のプランID', example: 2001 })
export type planId = z.infer<typeof planIdZ>

export const propertyIdZ = z
  .number()
  .nullable()
  .openapi({ description: '課金対象の物件ID', example: 3001 })
export type propertyId = z.infer<typeof propertyIdZ>

export const roomIdZ = z
  .number()
  .nullable()
  .openapi({ description: '課金対象の部屋ID', example: 4001 })
export type roomId = z.infer<typeof roomIdZ>

export const tenantIdZ = z
  .number()
  .nullable()
  .openapi({ description: '課金対象の賃借人ID', example: 6001 })
export type tenantId = z.infer<typeof tenantIdZ>

export const planMasterIdZ = z
  .string()
  .max(255)
  .openapi({ description: 'プランマスタID', example: 'plan_standard' })
export type planMasterId = z.infer<typeof planMasterIdZ>

export const planNameZ = z.string().max(100).openapi({
  description: 'プラン名（請求作成時点のスナップショット）',
  example: 'Standard Plan',
})
export type planName = z.infer<typeof planNameZ>

export const propertyNameZ = z.string().max(255).openapi({
  description: '物件名（請求作成時点のスナップショット）',
  example: 'サンプルマンション',
})
export type propertyName = z.infer<typeof propertyNameZ>

export const roomNameZ = z.string().max(255).openapi({
  description: '部屋名（請求作成時点のスナップショット）',
  example: '201号室',
})
export type roomName = z.infer<typeof roomNameZ>

export const tenantNameZ = z.string().max(255).openapi({
  description: '賃借人名（請求作成時点のスナップショット）',
  example: '山田太郎',
})
export type tenantName = z.infer<typeof tenantNameZ>

export const monthlyPriceZ = z
  .number()
  .int()
  .openapi({ description: '月額料金（円・税抜）', example: 12000 })
export type monthlyPrice = z.infer<typeof monthlyPriceZ>

export const stripeInvoiceItemIdZ = z
  .string()
  .max(255)
  .nullable()
  .openapi({ description: 'Stripe側の請求明細ID', example: 'ii_1PnXXXXXXX' })
export type stripeInvoiceItemId = z.infer<typeof stripeInvoiceItemIdZ>

export const descriptionZ = z
  .string()
  .max(1000)
  .nullable()
  .openapi({ description: '明細の説明文', example: 'Standardプラン 月額料金' })
export type description = z.infer<typeof descriptionZ>

export const createdAtStringZ = z.string().openapi({
  description: '作成日時（ISO8601）',
  example: '2024-03-01T00:00:00.000Z',
})
export type createdAtString = z.infer<typeof createdAtStringZ>

export const createdAtDateZ = z
  .date()
  .openapi({ example: '2024-03-01T00:00:00.000Z' })
export type createdAtDate = z.infer<typeof createdAtDateZ>

export const updatedAtStringZ = z.string().openapi({
  description: '更新日時（ISO8601）',
  example: '2024-03-10T00:00:00.000Z',
})
export type updatedAtString = z.infer<typeof updatedAtStringZ>

export const updatedAtDateZ = z
  .date()
  .openapi({ example: '2024-03-10T00:00:00.000Z' })
export type updatedAtDate = z.infer<typeof updatedAtDateZ>
